import LegalPage from '../components/LegalPage';
import privacyBody from '../content/legal/privacy.body.html?raw';

export default function PrivacyPolicyPage() {
  return <LegalPage title="Privacy Policy" bodyHtml={privacyBody} />;
}
